import { format } from 'date-fns-tz';

export const formatTz: typeof format = (...props) => format(...props);
